import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  month: number;
  year: number;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  month: moment().month() + 1,
  year: moment().year(),
  data: [],
};

const getListFeedbackManagerSlice = createSlice({
  name: "getListFeedbackManager",
  initialState,
  reducers: {
    setMonthYearListFeedbackManager: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getListFeedbackManagerStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListFeedbackManagerSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListFeedbackManagerFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    updateListFeedbackManager: (state, action) => {
      state.data = action.payload;
    },
    resetListFeedbackManager: () => {
      return { ...initialState };
    },
  },
});

export const {
  setMonthYearListFeedbackManager,
  getListFeedbackManagerStart,
  getListFeedbackManagerSuccess,
  getListFeedbackManagerFailed,
  updateListFeedbackManager,
  resetListFeedbackManager,
} = getListFeedbackManagerSlice.actions;

export default getListFeedbackManagerSlice.reducer;
